import React, {useEffect} from 'react';
import {Button, Divider, Form, Modal, Select} from "antd";
import {StorageBoxIcon} from "@components/icons/Icons";
import {useCollectionAssignConditionMutation, useSeriesAssignConditionMutation} from "@mwServices/User";
import {showResponse} from "@services/Api";

interface AssignConditionModalProps {
    isModalOpen: boolean;
    onCancel: () => void;
    selectedComicIds?: number[];
    selectedSeriesIds?: number[];
}
const AssignConditionModal = ({isModalOpen, onCancel, selectedComicIds, selectedSeriesIds}: AssignConditionModalProps) => {
    const [assignIssueCondition, assignIssueConditionResponse] = useCollectionAssignConditionMutation();
    const [assignSeriesCondition, assignSeriesConditionResponse] = useSeriesAssignConditionMutation();
    const [form] = Form.useForm();

    useEffect(() => {
        showResponse(assignIssueConditionResponse, 'Issue grade set.', 'Sorry, there was a problem setting the grade on the issues.');
        onCancel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignIssueConditionResponse]);
    useEffect(() => {
        showResponse(assignSeriesConditionResponse, 'Series grade set.', 'Sorry, there was a problem setting the grade on the series.');
        onCancel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignSeriesConditionResponse]);

    return (
        <Modal title={null} open={isModalOpen} onCancel={onCancel} centered={true} destroyOnClose={true} footer={null} className="edit-condition-modal">
            <Form
                layout="vertical"
                form={form}
                initialValues={{
                    graded_by: 'RAW',
                    grade: '',
                }}
                onFinish={async (values: any) => {
                    if(selectedComicIds){
                        let sanitisedData = {
                            issue_ids: selectedComicIds,
                        };

                        sanitisedData = {...sanitisedData, ...values};
                        await assignIssueCondition(sanitisedData);
                    }
                    if(selectedSeriesIds){
                        let sanitisedData = {
                            series_ids: selectedSeriesIds,
                        };

                        sanitisedData = {...sanitisedData, ...values};
                        assignSeriesCondition(sanitisedData);
                    }
                }}
            >
                <div className="text-center">
                    <StorageBoxIcon className="icon50" /><br/>
                    <span>Assign Grade</span>
                </div>
                <Divider />
                <div>
                    <p>Assign the same grade to all the items selected.</p>
                    <Form.Item label="Select Grading Company or Raw:"  name="graded_by">
                        <Select>
                            <Select.Option value="RAW">RAW</Select.Option>
                            <Select.Option value="CGC">CGC</Select.Option>
                            <Select.Option value="CBCS">CBCS</Select.Option>
                            <Select.Option value="PSA">PSA</Select.Option>
                            <Select.Option value="PGX">PGX</Select.Option>
                            <Select.Option value="EGS">EGS</Select.Option>
                            <Select.Option value="BECKETT">BECKETT</Select.Option>
                            <Select.Option value="HALO">HALO</Select.Option>
                            <Select.Option value="OTHER">OTHER</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label="Select a Grade:" name="grade">
                        <Select>
                            <Select.Option value="">No Rating</Select.Option>
                            <Select.Option value="10.0">10.0 - Gem Mint</Select.Option>
                            <Select.Option value="9.9">9.9 - Mint</Select.Option>
                            <Select.Option value="9.8">9.8 - Near Mint / Mint</Select.Option>
                            <Select.Option value="9.6">9.6 - Near Mint+</Select.Option>
                            <Select.Option value="9.4">9.4 - Near Mint</Select.Option>
                            <Select.Option value="9.2">9.2 - Near Mint-</Select.Option>
                            <Select.Option value="9.0">9.0 - Very Fine / Near Mint</Select.Option>
                            <Select.Option value="8.5">8.5 - Very Fine+</Select.Option>
                            <Select.Option value="8.0">8.0 - Very Fine</Select.Option>
                            <Select.Option value="7.5">7.5 - Very Fine-</Select.Option>
                            <Select.Option value="7.0">7.0 - Fine / Very Fine</Select.Option>
                            <Select.Option value="6.5">6.5 - Fine+</Select.Option>
                            <Select.Option value="6.0">6.0 - Fine</Select.Option>
                            <Select.Option value="5.5">5.5 - Fine-</Select.Option>
                            <Select.Option value="5.0">5.0 - Very Good / Fine</Select.Option>
                            <Select.Option value="4.5">4.5 - Very Good+</Select.Option>
                            <Select.Option value="4.0">4.0 - Very Good</Select.Option>
                            <Select.Option value="3.5">3.5 - Very Good-</Select.Option>
                            <Select.Option value="3.0">3.0 - Good / Very Good</Select.Option>
                            <Select.Option value="2.5">2.5 - Good+</Select.Option>
                            <Select.Option value="2.0">2.0 - Good</Select.Option>
                            <Select.Option value="1.8">1.8 - Good-</Select.Option>
                            <Select.Option value="1.5">1.5 - Fair/Good</Select.Option>
                            <Select.Option value="1.0">1.0 - Fair</Select.Option>
                            <Select.Option value="0.5">0.5 - Poor</Select.Option>
                        </Select>
                    </Form.Item>
                </div>
                <Divider />
                <div className="text-center">
                    <Button type="primary"  shape="round"  size="large" htmlType="submit">
                        SUBMIT
                    </Button><br/>
                    <Button type="link" onClick={onCancel} >CANCEL</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default AssignConditionModal;